<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="disabled.1"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path id="Path_8542" data-name="Path 8542" d="M0,0H20V20H0Z" fill="none" />
    <path
      id="Path_8543"
      data-name="Path 8543"
      d="M12.858,8.142,8.142,12.858m4.717,0L8.142,8.142M10.5,18h0A7.5,7.5,0,0,1,3,10.5H3A7.5,7.5,0,0,1,10.5,3h0A7.5,7.5,0,0,1,18,10.5h0A7.5,7.5,0,0,1,10.5,18Z"
      transform="translate(-0.5 -0.5)"
      fill="none"
      :stroke="clr ? clr : '#ec484a'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
